/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import {
    TableRow, TableCell, Checkbox, Typography,
    Collapse, TableBody, Table, Button, Box, FormControlLabel, Switch
} from "@mui/material";
import { Image, Space, Dropdown, Menu } from "antd";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import DropDownSort from "../../../../../assets/images/icon_actions/DropDownSort.svg";
import DropDownSort1 from "../../../../../assets/images/icon_actions/DropDownSort1.svg";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { useDispatch, useSelector } from "react-redux";
import { emptyValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import TickIcon from "../../../../../assets/images/icon_actions/Tick Mark.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDPermission } from "../../../../../helpers/utilities";

const ComponentTable = (props) => {
    const { showDetails, rows, component, type, componentDetails, featureComponentDetails, roleId,
        loadTasks, changeComponentVisible, checkErrorComponentId, roleManagement,
        emptyState, changeComponentHandler, componentPermisionHead } = props;
    const { createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const [deleteModal, setDeleteModal] = useState(false);
    const [componentId, setComponentId] = useState('');
    const [name, setName] = useState('');
    const [featureName, setFeatureName] = useState('');
    const [featureId, setFeatureId] = useState('');
    const [errorComponentId, setErrorComponentId] = useState(checkErrorComponentId);
    const [componentType, setComponentType] = useState([]);
    const [componentTypeId, setComponentTypeId] = useState([]);
    const [selected, setSelected] = useState([]);
    const [addMore, setAddMore] = useState(false);
    const [visible, setVisible] = useState(false);


    const dispatch = useDispatch();

    const [form, setForm] = useState({
        componentId: "",
        enabled: false,
        roleId: parseInt(roleId)
    });

    const changeHandler = (e, name = "") => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });

        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
            });
        }
    };

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleOpen = (data) => {
        setFeatureName(data?.feature?.featureName);
        setFeatureId(data?.featureId);
        setVisible(true);
        changeComponentVisible(true);
        emptyStateInput();
        emptyCState();
    };

    const handleClose = () => {
        setVisible(false);
        changeComponentVisible(false);
        emptyStateInput();
        emptyCState();
    };

    const emptyStateInput = () => {
        setForm({
            ...form,
            componentId: "",
            enabled: false,
        });
        setComponentTypeId('');
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        setErrorComponentId(checkErrorComponentId);
    }, [checkErrorComponentId]);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            handleClose();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        }
    }, [createDetails, createError]);

    const onEdit = (data) => {
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = [data.id];
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        setSelected(newSelected);
    }

    const onComponentDelete = (data) => {
        setDeleteModal(true);
        setComponentId(data?.id);
        setName(data?.component?.component);
    }

    const emptyCState = () => {
        setErrorComponentId(false);
        emptyState();
    }

    const createComponent = (e) => {
        e.preventDefault();
        let emptyComponentId = emptyValidation('Component', form.componentId, 'dropDown');
        emptyCState();
        if (emptyComponentId.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'componentPermissions',
                title: 'Component Permissions',
                details: form
            });
        } else {
            if (emptyComponentId.errors) {
                setErrorComponentId(emptyComponentId.errors);
            }
        }
    }

    const handleAddMore = (e) => {
        createComponent(e);
        setAddMore(true);
    }

    const handleChangeComponent = (value, name) => {
        let f = featureComponentDetails.filter(function (el) { return el.id === value });
        let c = componentDetails.filter(function (el) { return f.find(e => e.componentTypeId === el.id) });
        setComponentType(c);
        setComponentTypeId(c[0].id);
        setForm({
            ...form,
            [name]: value,
            //'componentTypeId': c[0].id
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            {
                showDetails || rows === '' ? (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell style={{ textAlign: "center" }} colSpan={componentPermisionHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                    </TableRow>
                ) : rows && rows?.length > 0 ? rows?.map((data, i) => (
                    <React.Fragment key={`feature_${data.featureId}`}>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                            <TableCell style={{ width: "20%" }}>
                                <NavLink to={"#"} onClick={() => onEdit(data)} className={clsx(classes.customLink)}>
                                    <Image
                                        src={selected && selected.find(e => e === data.id) ? DropDownSort : DropDownSort1}
                                        preview={false} />
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.LightBlue, classes.bold, classes.marginLeft10)}
                                    >{data?.feature?.featureName}</Typography>
                                </NavLink>
                            </TableCell>
                            <TableCell style={{ width: "20%" }}>{data?.feature?.module?.module}</TableCell>
                            <TableCell style={{ width: "20%" }}></TableCell>
                            <TableCell style={{ width: "10%" }}></TableCell>
                            <TableCell style={{ width: "10%" }}></TableCell>
                            <TableCell style={{ width: "20%" }}>
                                {
                                    selected && selected.find(e => e === data.id) ?
                                        <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') &&
                                                <NavLink to="#" className={clsx(classes.customLink)} onClick={() => handleOpen(data)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Component</span>
                                                </NavLink>
                                            }
                                        </Space> : <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                <Image src={ViewIcon} preview={false} />
                                            </NavLink>
                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                <Image src={EditIcon} preview={false} />
                                            </NavLink>
                                            <Dropdown trigger={['click']} placement={'bottomRight'}
                                                overlay={
                                                    <Menu className={clsx(classes.groupMenu)}>
                                                        <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') &&
                                                            <Menu.Item><NavLink to={'#'} onClick={() => handleOpen(data)}>Add Component</NavLink></Menu.Item>
                                                        }
                                                    </Menu>
                                                }>
                                                <Image src={ElipsisIcon} preview={false} />
                                            </Dropdown>
                                        </Space>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                <Collapse className={classes.collapseTable} in={selected && selected.find(e => e === data.id) ? true : false} timeout="auto" unmountOnExit>
                                    <Table size="small" aria-label="purchases">
                                        <TableBody>
                                            {
                                                component && component.length > 0 && component.filter(component => component.component.featureId === data.featureId).map((data, i) => (
                                                    <TableRow key={`component_${data.componentId}`}>
                                                        <TableCell style={{ width: "20%" }}></TableCell>
                                                        <TableCell style={{ width: "20%" }}></TableCell>
                                                        <TableCell style={{ width: "20%" }}>{data?.component?.component}</TableCell>
                                                        <TableCell style={{ width: "10%" }}>{data?.component?.componentType?.componentType}</TableCell>
                                                        <TableCell style={{ width: "10%" }}>
                                                            {
                                                                type === 'view' ? (
                                                                    data.enabled && <Image src={TickIcon} preview={false} />
                                                                ) : (
                                                                    <Checkbox name={"enabled"} checked={data.enabled} onChange={(e) => changeComponentHandler(data, e)} />
                                                                )
                                                            }
                                                        </TableCell>
                                                        <TableCell style={{ width: "20%" }}>
                                                            <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                                {
                                                                    roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') &&
                                                                    <NavLink to={"#"} onClick={() => onComponentDelete(data)}>
                                                                        <Image src={DeleteIcon} preview={false} />
                                                                    </NavLink>
                                                                }
                                                            </Space>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    </React.Fragment>
                )) : (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell className={classes.textAlignCenter} colSpan={componentPermisionHead.length}>
                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No Feauture Component Permission Added Here'}</p>
                        </TableCell>
                    </TableRow>
                )
            }
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Add Component'}
                width={'360px'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createComponent(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Feature</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{featureName}</Typography>
                            <AutoCompleteComponent
                                name={["Component ", <span key={"Component"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'component', 'name': 'Name' }]}
                                details={featureId ? featureComponentDetails.filter(function (el) { return el.featureId === featureId }) : []}
                                parentValue={customObject(featureId ? featureComponentDetails.filter(function (el) { return el.featureId === featureId }) : [], form.componentId)}
                                onChange={(data) => handleChangeComponent(data.id, "componentId")}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                                parentError={errorComponentId}
                            />
                            <AutoCompleteComponent
                                name={["Select Component Type ", <span key={"Select Component Type"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'componentType', 'name': 'Name' }]}
                                details={componentType}
                                parentValue={customObject(componentType, componentTypeId)}
                                // onChange={(data) => changeHandler(data.id, "componentTypeId")}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                                parentError={errorComponentId}
                            />
                            <FormControlLabel
                                label="Enable / Disable"
                                labelPlacement="start"
                                name={"enabled"}
                                className={clsx(classes.margin30t, classes.switchAlignfont14, classes.switchAlign)}
                                control={
                                    <Switch
                                        className={clsx(classes.marginLeft10, classes.customSwitch)}
                                        size="small" name={"enabled"} checked={form.enable} onChange={(e) => changeHandler(e)} />

                                }
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                >
                                    Save & Close
                                </Button>
                                <Button
                                    key="add"
                                    onClick={(e) => handleAddMore(e)}
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                >
                                    Add more
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} loadTasks={() => loadTasks()} name={name} id={componentId} url={'componentPermissions'} title={'Component Permision'} visible={deleteModal} />
        </React.Fragment>
    );
}

export default ComponentTable;